const DIFER_IMG = '/img/dif.jpg';

const diferenciais = [
  { icon: 'ri-time-line', title: 'Atendimento sem pressa', desc: 'Identificação de necessidades antes que se tornem problemas.' },
  { icon: 'ri-mental-health-line', title: 'Prevenção Ativa', desc: 'Estratégias personalizadas de cuidado contínuo e preventivo.' },
];

export default function DiferenciaisSection() {
  return (
    <section id="diferenciais" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-[2px] bg-gradient-to-r from-[#4F5D4A] to-[#6B705C]"></div>
              <span className="text-sm font-semibold text-[#6B705C] uppercase tracking-wider">Diferenciais</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#3A3A3A] mb-8 leading-tight">
              Cuidado com um olhar{' '}
              <span className="text-[#6B705C]">mais humano e completo</span>
            </h2>
            <div className="space-y-5 text-[#3A3A3A]/70 leading-relaxed text-base">
              <p>
                Minha atuação é baseada na <strong className="text-[#3A3A3A]">escuta, no acolhimento</strong> e na
                construção de um acompanhamento contínuo, respeitando a individualidade de cada paciente.
              </p>
              <p>
                Acredito que o verdadeiro cuidado envolve o olhar físico, emocional e social — porque saúde é{' '}
                <strong className="text-[#3A3A3A]">muito mais que ausência de doença</strong>.
              </p>
              <p className="text-[#6B705C] font-semibold text-lg italic">
                "Cuidar hoje é viver melhor em todas as fases da vida."
              </p>
            </div>
            <div className="mt-10 grid grid-cols-2 gap-6">
              {diferenciais.map((d) => (
                <div key={d.title} className="bg-[#F5F5F0] p-6 rounded-xl border border-[#DDE0D7]/50">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#4F5D4A] to-[#6B705C] rounded-lg flex items-center justify-center mb-4">
                    <i className={`${d.icon} text-xl text-white`}></i>
                  </div>
                  <h4 className="font-bold text-[#3A3A3A] mb-2 text-sm">{d.title}</h4>
                  <p className="text-xs text-[#3A3A3A]/60 leading-relaxed">{d.desc}</p>
                </div>
              ))}
            </div>
          </div>
          {/* Image */}
          <div className="relative">
            <div className="absolute -top-4 -right-4 w-full h-full border-2 border-[#6B705C]/20 rounded-2xl"></div>
            <img
              src={DIFER_IMG}
              alt="Acompanhamento médico humanizado"
              className="relative w-full h-[450px] object-cover object-top rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}